export const routes = {
  portal: {
    base: "/",
    root: "/*",
    drawer: "?drawer",
    customerSupport: "?drawer=customer-support",
  },
  authRedirect: { base: "/auth-redirect" },
  signout: { base: "/sign-out" },
  statements: {
    base: "/statements-reports",
    root: "/statements-reports/*",
    view: "/statements-reports/:id",
  },
  statementImports: {
    base: "/statement-imports",
    root: "/statement-imports/*",
    view: "/statement-imports/:id",
  },
  socialClearances: {
    base: "/social-clearance",
    root: "/social-clearance/*",
    clearanceList: "/social-clearance/clearances",
    clearanceView: "/social-clearance/clearances/:id",
    clearanceEdit: "/social-clearance/clearances/:id/edit",
    clearanceCreate: "/social-clearance/clearances/create",
    clientList: "/social-clearance/clients",
    clientView: "/social-clearance/clients/:id",
    clientEdit: "/social-clearance/clients/:id/edit",
    clientCreate: "/social-clearance/clients/create",
  },
  signing: {
    base: "/signing",
    root: "/signing/*",
    thankyou: "/signing/thankyou",
  },
  payouts: {
    base: "/payouts",
    root: "/payouts/*",
  },
  payoutAdministration: {
    base: "/payout-administration",
    root: "/payout-administration/*",
    eligible: "/payout-administration/eligible",
    onHold: "/payout-administration/on-hold",
    batches: "/payout-administration/batches",
    batch: "/payout-administration/batches/:id",
  },
  notifications: {
    base: "/notifications",
    root: "/notifications/*",
  },
  resources: {
    base: "/resources",
    root: "/resources/*",
    view: "/resources/:id",
  },
  msa: {
    base: "/msa",
    root: "/msa/*",
    dashboard: "/msa/dashboard",
    faq: "/msa/faq",
  },
  music: {
    base: "/music",
    root: "/music/*",
    discover: {
      base: "/music/discover",
      search: "/music/discover/search",
      searchResults: "/music/discover/search/results",
      searchTrack: "/music/discover/search/track/:id",
      playlists: "/music/discover/playlists",
      playlistView: "/music/discover/playlists/:id",
      playlistsCurated: "/music/discover/playlists/curated",
      playlistsCuratedCategory: "/music/discover/playlists/curated/:category",
      trackView: "/music/discover/track/:id",
      trackSimilar: "/music/discover/track/:id/similar",
      trackDetails: "/music/discover/track/:id/details",
      trackAudioVersions: "/music/discover/track/:id/audio-versions",
      trackLyrics: "/music/discover/track/:id/lyrics",
      artistView: "/music/discover/artist/:id",
    },
    library: {
      base: "/music/library",
      playlists: "/music/library/playlists",
      downloads: "/music/library/downloads",
      liked: "/music/library/liked-tracks",
      recent: "/music/library/recent-listens",
    },
    connect: {
      base: "/music/connect",
      channels: "/music/connect/channels",
      collections: "/music/connect/collections",
      collectionView: "/music/connect/collections/:id",
      bulkImportChannels: "/music/connect/bulk-import-channels",
      deactivatedChannels: "/music/connect/deactivated-channels",
    },
    shared: {
      base: "/music/shared",
      root: "/music/shared/*",
      trackView: "/music/shared/track/:shareToken",
      trackDetails: "/music/shared/track/:shareToken/details",
      playlistView: "/music/shared/playlist/:shareToken",
      artistView: "/music/shared/artist/:shareToken",
    },
  },
  licenses: {
    base: "/licenses",
    root: "/licenses/*",
    commercialLicenses: "/licenses/commercial",
    commercialLicenseView: "/licenses/commercial/:id",
    libraryLicenses: "/licenses/library",
    libraryLicenseView: "/licenses/library/:id",
  },
  legal: {
    base: "/legal",
    root: "/legal/*",
    documents: "/legal/documents",
    acceptances: "/legal/acceptances",
    documentEdit: "/legal/documents/:key/edit",
    documentEditSettings: "/legal/documents/:key/edit/settings",
    documentEditDocument: "/legal/documents/:key/edit/document",
    documentEditConfirmations: "/legal/documents/:key/edit/confirmations",
    documentEditHistory: "/legal/documents/:key/edit/history",
    documentEditAudience: "/legal/documents/:key/edit/audience",
    documentEditVersions: "/legal/documents/:key/edit/versions",
  },
  orgs: {
    base: "/orgs",
    root: "/orgs/*",
    none: "/orgs/none",
    create: "/orgs/new",
    inviteAccept: "/orgs/invite/:id",
    inviteCreate: "/orgs/current/invite",
    settings: "/orgs/current/settings",
    settingsDetails: "/orgs/current/settings/details",
    settingsModules: "/orgs/current/settings/modules",
    settingsBranding: "/orgs/current/settings/branding",
    users: "/orgs/current/users",
    usersActive: "/orgs/current/users/active",
    usersInvited: "/orgs/current/users/invited",
    usersInactive: "/orgs/current/users/inactive",
  },
  musicIngestion: {
    base: "/music-ingestion",
    root: "/music-ingestion/*",
  },
  distribution: {
    base: "/distribution",
    root: "/distribution/*",
    subscribe: "/distribution/subscribe",
  },
  reporting: {
    base: "/reporting",
    root: "/reporting/*",
    report: "/reporting/:key",
  },
  labs: {
    base: "/labs",
    root: "/labs/*",
    apps: "/labs/apps/:category?",
    app: "/labs/app/:id",
    edit: {
      base: "/labs/app/:id/edit",
      settings: "/labs/app/:id/edit/settings",
      modules: "/labs/app/:id/edit/modules",
      parameters: "/labs/app/:id/edit/parameters",
      secrets: "/labs/app/:id/edit/secrets",
      access: "/labs/app/:id/edit/access",
      roles: "/labs/app/:id/edit/roles",
      development: "/labs/app/:id/edit/development",
      datastore: "/labs/app/:id/edit/datastore",
      rateLimits: "/labs/app/:id/edit/rate-limits",
      legal: "/labs/app/:id/edit/legal",
      datastoreEditor: "/labs/app/:id/edit/datastore/:tableName",
    },
  },
};
